import BaseAPI from "./api";
import env from "../environment";
import { AppConstants } from "../constants/AppConstants";
import axios from "axios";
import { isEmpty } from "lodash";
import { themeJSON } from "../constants/ThemeConstants";

const API = BaseAPI?.axiosInstance;

export const listBuckets = async (
  page: number = AppConstants.DEFAULT_PAGE,
  size: number = AppConstants.DEFAULT_PAGE_SIZE
) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  const response = await API.get(`/bucket?page=${page}&size=${size}`, {
    headers,
  });
  return response;
};

export const listFiles = async (
  body: any,
  queryParams: { [key: string]: string | number },
  sort: Array<string> = []
) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  let uri = `/${env.assetManagementPath}/listFiles?page=${queryParams.page}&size=${queryParams.size}`;
  if (sort.length) {
    uri += "&" + sort.map((e: string) => `sort=${e}`).join("&");
  }
  const response = await API.post(uri, body, { headers });
  return response;
};

export const getThemColors = async () => {
  let result;
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  const themeURL = AppConstants.getThemeUrl();
  await fetch(`${themeURL}`, {
    headers: {
      ...headers,
      [AppConstants.HEADER_ACCEPT]: AppConstants.VALUE_APPLICATION_JSON,
    },
  })
    .then((response) => response.json())
    .then((data) => {
      result = data;
    })
    .catch((error) => {
      result = themeJSON;
    });
  return result;
};

export const createSignedURL = async (body: any) => {
  const headers = { ...AppConstants.GLOBAL_HEADERS };
  const response = await API.post(`/${env.assetManagementPath}/createSignedURL`, body, { headers });
  return response;
};

export const uploadFile = async (
  payload: any,
  success?: Function,
  error?: Function
) => {
  const axiosInstance = axios.create();
  const response = await axiosInstance.put(payload?.url, payload?.body, {
    headers: {
      ...payload?.headers,
    },
  });
  return response;
};

export const getGCPFile = async (url: string, customHeaders: any = {}) => {
  let headers = { ...AppConstants.GLOBAL_HEADERS };
  if (!isEmpty(customHeaders)) {
    headers = { ...headers, ...customHeaders };
  }
  const response = await axios.get(url, { headers });
  return response;
};
